import React, { useState, useEffect } from 'react'
import StatsComponent2 from '../../../BuisnessDashboard/common/StatsComponent2'
import { OctagonAlert, Search, TrendingUp } from 'lucide-react'
import { getLoanStatsByAggregatorIdbyName, getAggrrgaotrEventsByAggregatorIdbyName } from '../../ActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import moment from 'moment'
export default function Overview({ Data, dateFilterPopup, commonFilter, setDateFilterPopup }) {
    const [loader, setLoader] = useState(false)
    const [funnelData, setFunnelData] = useState({})
    const [statsData, setstatsData] = useState([])

    useEffect(() => {
        if (
            commonFilter?.fromDate !== dateFilterPopup.from ||
            commonFilter?.toDate !== dateFilterPopup.to
        ) {
            setDateFilterPopup((prev) => ({
                ...prev,
                from: commonFilter.fromDate,
                to: commonFilter.toDate
            }));
        }
        const obj = { start: moment(commonFilter.fromDate).format("DD-MM-YYYY"), end: moment(commonFilter.toDate).format("DD-MM-YYYY") }
        FunnelDataApi(obj)
        StepperApi(obj)
    }, [commonFilter])

    const FunnelDataApi = (obj) => {
        setLoader(true)
        getLoanStatsByAggregatorIdbyName(obj?.start ?? "", obj?.end ?? "", Data?.id ?? "", Data?.name ?? "", callback => {
            // getLoanStatsByAggregatorIdbyName("01-01-2026","29-01-2026","7531c62ef9444b29",callback=>{
            setLoader(false)
            setFunnelData(callback?.data ?? {})
        })
    }
    const StepperApi = (obj) => {
        setLoader(true)
        getAggrrgaotrEventsByAggregatorIdbyName(obj?.start ?? "", obj?.end ?? "", Data?.id ?? "", callback => {
            // getAggrrgaotrEventsByAggregatorIdbyName("01-01-2026","29-01-2026","7531c62ef9444b29",callback=>{
            setLoader(false)
            const data = callback?.data?.events ?? [];

            const eventsMap = (callback?.data?.events || []).reduce((acc, item) => {
                acc[item.event] = item;
                return acc;
            }, {});
            // setstatsData([
            //     { value: eventsMap["LOGIN_MOBILE"]?.percentage, name: "entered Basic stage", color: "#6EBA80" },
            //     { value: eventsMap["EMPLOYEE_TYPE"]?.percentage, name: "rejected at 1st Level Rejection", color: "#6EBA80E5" },
            //     { value: eventsMap["AADHAAR_KYC_SUCCESS"]?.percentage, name: "moved to KYC Verification", color: "#6EBA80CC" },
            //     { value: eventsMap["PAN_KYC_SUCCESS"]?.percentage, name: "Completed Eligibility Form", color: "#6EBA80B2" },
            //     { value: eventsMap["DOCUMENTS_ADDED_SUCCESSFULLY"]?.percentage, name: "received Loan Offer", color: "#6EBA8099" },
            //     { value: eventsMap["SELFIE_ADDED_SUCCESSFULLY"]?.percentage, name: "provided More Info", color: "#6EBA8080" },
            //     { value: eventsMap["LOAN_FORM_COMPLETED"]?.percentage, name: "Submitted Bank Details", color: "#6EBA8066" },
            //     { value: eventsMap["EMPLOYEE_TYPE"]?.percentage, name: "uploaded Documents", color: "#6EBA804D" },
            //     { value: eventsMap["EMPLOYEE_TYPE"]?.percentage, name: "completed Loan Application", color: "#6EBA8033" },
            //     { value: eventsMap["EMPLOYEE_TYPE"]?.percentage, name: "Reached Complete", color: "#F0B96C" },
            // ])
            setstatsData([
                { value: eventsMap["LOGIN_MOBILE"]?.percentage, name: "entered Basic stage", color: "#6EBA80B2" },
                { value: eventsMap["EMPLOYEE_TYPE"]?.percentage, name: "Employee Type", color: "#6EBA8099" },
                { value: eventsMap["AADHAAR_KYC_SUCCESS"]?.percentage, name: "moved to KYC Verification", color: "#6EBA8080" },
                { value: eventsMap["PAN_KYC_SUCCESS"]?.percentage, name: "Completed Eligibility Form", color: "#6EBA8066" },
                { value: eventsMap["DOCUMENTS_ADDED_SUCCESSFULLY"]?.percentage, name: "uploaded Documents", color: "#6EBA804D" },
                { value: eventsMap["SELFIE_ADDED_SUCCESSFULLY"]?.percentage, name: "uploaded Documents", color: "#6EBA8033" },
                { value: eventsMap["LOAN_FORM_COMPLETED"]?.percentage, name: "completed Loan Application", color: "#F0B96C" },

            ])
        })
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div>
                    <StatsComponent2
                        heading={"Lead Conversion Funnel"} Data={statsData}
                        centerText={`Out of ${"12,450"} leads`}
                    />
                </div>

                <div className='row'>
                    <div className="col-lg-4 col-sm-6 col-xs-12" style={{ marginTop: '30px' }}>
                        <div className="customcard-overview" style={{ height: "480px" }}>
                            <div className="topHeader">
                                <h5>Lead Quality (KPIs)</h5>
                            </div>

                            <div className="funnelBars" style={{ margin: '17px 0' }}>
                                <div className='barss green-bar'>
                                    <h5>Total Leads Received</h5>
                                    <h5><b>{funnelData?.stats?.totalLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss dark-yellow-bar'>
                                    <h5>Unique Leads </h5>
                                    <h5><b>{funnelData?.stats?.uniqueLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss blue-bar'>
                                    <h5>Approved</h5>
                                    <h5><b>{funnelData?.stats?.approveLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss redish-bar'>
                                    <h5>Disbursed</h5>
                                    <h5><b>{funnelData?.stats?.disburseLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss purpleish-bar'>
                                    <h5>Ongoing</h5>
                                    <h5><b>{funnelData?.stats?.ongoingLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss yellow-bar'>
                                    <h5>Paid</h5>
                                    <h5><b>{funnelData?.stats?.paidLeads ?? 0}</b></h5>
                                </div>
                                <div className='barss orange-bar'>
                                    <h5>Overdue</h5>
                                    <h5><b>{funnelData?.stats?.overdueLeads ?? 0}</b></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-xs-12" style={{ marginTop: '30px' }}>
                        <div className="customcard-overview" style={{ height: "480px" }}>
                            <div className="topHeader">
                                <h5>Actionable Recommendations</h5>
                            </div>
                            <div className="Center-cards-columns">
                                <h5 style={{ margin: "20px 0" }}>Auto-generated suggestions based on KPI thresholds</h5>
                                {
                                    funnelData?.conversion?.action == "SCALE" ?
                                        <div className='card-box'>
                                            <div className='img-circle' style={{ background: "#35A04F" }}><TrendingUp /></div>
                                            <div className="content">
                                                <h4>Scale</h4>
                                                <h6 className='custom'>Condition: <b>{'conversion ratio > 7%'}</b></h6>
                                                <hr style={{ margin: '5px 0' }} />
                                                <h6>Aggregator is performing very well, consider Scaling up.</h6>
                                            </div>
                                        </div>
                                        : ""}
                                {
                                    funnelData?.conversion?.action == "OPTIMIZE" ?
                                        <div className='card-box'>
                                            <div className='img-circle' style={{ background: "#F49F28" }}><Search /></div>
                                            <div className="content">
                                                <h4>Optimize</h4>
                                                <h6 className='custom'>Condition: <b>{'conversion ratio <= 7% & > 4%'}</b></h6>
                                                <hr style={{ margin: '5px 0' }} />
                                                <h6>Aggregator has untapped potential, but needs improvement in initial stages.</h6>
                                            </div>
                                        </div>
                                        : ""}
                                {
                                    funnelData?.conversion?.action == "PAUSE" ?
                                        <div className='card-box'>
                                            <div className='img-circle' style={{ background: "#EB6062" }}><OctagonAlert /></div>
                                            <div className="content">
                                                <h4>Pause</h4>
                                                <h6 className='custom'>Condition: <b>{'conversion ratio >= 4%'}</b></h6>
                                                <hr style={{ margin: '5px 0' }} />
                                                <h6>Aggregator is underperforming, pause campaigns and address root cause.</h6>
                                            </div>
                                        </div>
                                        : ""}

                                <h5 className='redish' style={{ marginTop: '20px' }}>Tip: Recommendations are based on real-time KPIs for quick decision-making</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 col-xs-12" style={{ marginTop: '30px' }}>
                        <div className="customcard-overview" style={{ height: "480px" }}>
                            <div className="topHeader">
                                <h5>Performance Scorecard</h5>
                                <div className='scores'>
                                    <h6>Score</h6>
                                    <h4>{funnelData?.scorecard?.totalScore ?? 0}/100</h4>
                                </div>
                            </div>

                            <div className="customProgress" style={{ marginTop: '30px' }}>
                                <div className='text'>
                                    <h5>Conversion %</h5>
                                    <h6>{funnelData?.scorecard?.conversionScore ?? 0}/25</h6>
                                </div>
                                <div className="progress-new">
                                    <div className="progressWidth" style={{ background: "#F1D0A1", width: funnelData?.scorecard?.conversionRatio ?? 0 + '%' }}></div>
                                </div>
                            </div>
                            <div className="customProgress" style={{ marginTop: '30px' }}>
                                <div className='text'>
                                    <h5>Cost Efficiency </h5>
                                    <h6>{funnelData?.scorecard?.costEfficiencyScore ?? 0}/25</h6>
                                </div>
                                <div className="progress-new">
                                    <div className="progressWidth" style={{ background: "#4877E4", width: funnelData?.scorecard?.costEfficiencyRatio ?? 0 + '%' }}></div>
                                </div>
                            </div>
                            {/* <div className="customProgress" style={{ marginTop: '25px' }}>
                                <div className='text'>
                                    <h5>Risk</h5>
                                    <h6>22/25</h6>
                                </div>
                                <div className="progress-new">
                                    <div className="progressWidth" style={{ background: "#E97979F0", width: '65%' }}></div>
                                </div>
                            </div> */}
                            <div className="customProgress" style={{ marginTop: '30px' }}>
                                <div className='text'>
                                    <h5>Lead Quality</h5>
                                    <h6>{funnelData?.scorecard?.leadQualityScore ?? 0}/25</h6>
                                </div>
                                <div className="progress-new">
                                    <div className="progressWidth" style={{ background: "#4FA7C7", width: funnelData?.scorecard?.leadQualityRatio ?? 0 + '%' }}></div>
                                </div>
                            </div>
                            <div className="customProgress" style={{ marginTop: '30px' }}>
                                <div className='text'>
                                    <h5>ROI Concentration</h5>
                                    <h6>{funnelData?.scorecard?.roiScore ?? 0}/25</h6>
                                </div>
                                <div className="progress-new">
                                    <div className="progressWidth" style={{ background: "#35A04FC4", width: funnelData?.scorecard?.roiRatio ?? 0 + '%' }}></div>
                                </div>
                            </div>

                            <h5 style={{ margin: '50px 0 0 0', padding: '0' }}><b>Recommendation</b></h5>
                            <h5 style={{ color: 'red', margin: '5px 0 17px 0', padding: '0' }}>Improve KYC completion before scaling.</h5>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
